import {
    Modal, ModalOverlay, ModalContent, ModalHeader,
    ModalBody, ModalCloseButton, Button, Box, Text, Flex, Heading, Divider, UnorderedList, ListItem
} from "@chakra-ui/react";

export default function LiveProjectModal({ isOpen, onClose, project }) {
    if (!project) return null;

    const story = project.fullStory;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
            <ModalOverlay backdropFilter="blur(12px)" bg="blackAlpha.800" />
            <ModalContent bg="#0a0a0a" color="white" borderRadius="3xl" border="1px solid #333">
                <ModalHeader borderBottom="1px solid #222" py={5}>
                    <Flex align="center" gap={3}>
                        <Box w="10px" h="10px" borderRadius="full" bg="red.500" />
                        <Text fontSize="2xl" fontWeight="900" letterSpacing="tight">{project.title}</Text>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton top={4} />

                <ModalBody p={0}>
                    <Box p={8} bgGradient="linear(to-b, #111, #0a0a0a)">
                        {story ? (
                            <Box>
                                <Text fontSize="xl" color="gray.200" mb={8} fontWeight="500">{story.intro}</Text>

                                <Heading size="xs" color="red.500" mb={4} textTransform="uppercase">Project Description</Heading>
                                <UnorderedList spacing={3} mb={8} color="gray.300">
                                    {story.details.map((item, i) => (
                                        <ListItem key={i}>
                                            <Text as="span" fontWeight="bold" color="white">{item.label}:</Text> {item.text}
                                        </ListItem>
                                    ))}
                                </UnorderedList>

                                <Divider borderColor="#222" mb={8} />

                                <Heading size="xs" color="red.500" mb={4} textTransform="uppercase">Personal Thoughts & Reflection</Heading>
                                <Text fontSize="lg" color="gray.300" mb={8}>{story.reflection}</Text>

                                <Box bg="#111" p={8} borderRadius="2xl" borderLeft="4px solid" borderColor="red.600" mb={6}>
                                    <Heading size="sm" color="red.500" mb={3}>The Verdict (Score: {story.score})</Heading>
                                    <Text fontStyle="italic" color="white" fontSize="xl" lineHeight="1.6">
                                        "{story.verdict}"
                                    </Text>
                                </Box>

                                {/* The Eye Contact Note */}
                                <Text color="gray.500" fontSize="sm" textAlign="right">
                                    {story.scoreNote}
                                </Text>
                            </Box>
                        ) : (
                            <Text fontSize="lg" color="gray.400">{project.description}</Text>
                        )}
                    </Box>

                    <Box px={8} pb={10}>
                        <Box borderRadius="20px" overflow="hidden" border="1px solid #444">
                            {/* Browser Header Bar */}
                            {/* Browser Header Bar */}
                            <Flex bg="#222" px={4} py={3} align="center" position="relative" justify="center">
                                {/* Window Control Dots positioned absolutely to the left */}
                                <Flex gap={2} align="center" position="absolute" left={4}>
                                    <Box w="10px" h="10px" borderRadius="full" bg="#ff5f56" />
                                    <Box w="10px" h="10px" borderRadius="full" bg="#ffbd2e" />
                                    <Box w="10px" h="10px" borderRadius="full" bg="#27c93f" />
                                </Flex>

                                {/* Perfectly Centered URL Pill */}
                                <Flex
                                    bg="#111"
                                    px={4}
                                    py={1.5}
                                    borderRadius="md"
                                    border="1px solid #333"
                                    maxW="450px"
                                    w="60%"
                                    align="center"
                                    justify="center"
                                    h="28px"
                                >
                                    <Text
                                        fontSize="xs"
                                        color="gray.400"
                                        fontFamily="monospace"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        m={0}
                                        p={0}
                                        lineHeight="normal"
                                        isTruncated
                                    >
                                        {project.link || "Private Link - Access Restricted"}
                                    </Text>
                                </Flex>
                            </Flex>

                            {/* Browser Body Image */}
                            <Box bg="#000">
                                <img src={project.image} alt={project.title} style={{ width: "100%", display: "block" }} />
                            </Box>
                        </Box>
                    </Box>
                </ModalBody>

                <Flex p={6} justify="space-between" bg="#0f0f0f" borderTop="1px solid #222" borderRadius="0 0 3xl 3xl">
                    <Button variant="link" color="gray.500" onClick={onClose}>Return to Gallery</Button>
                    {project.link && (
                        <Button as="a" href={project.link} target="_blank" bg="red.600" color="white" _hover={{ bg: "red.500" }}>
                            Launch Live Site
                        </Button>
                    )}
                </Flex>
            </ModalContent>
        </Modal>
    );
}